
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseForecastModalPage from './BaseForecastModalPage.vue';
import gdbx from '@/store/modules/gdbx';
import moment from 'moment';
import dbw from '@/worker/dbw';
import { getTableName, sqlExtractYear, sqlExtractMonth } from '../../../worker/db/sqlHelpers';
import ForecastModalMonth from './components/ForecastModalMonth.vue';

@Component({
	components: { ForecastModalMonth },
})
export default class ForecastModalLoadFixedExpenses extends BaseForecastModalPage {
	public manualFixedExpensesGrowth = '0';
	public showLoading = false;

	public async loadExpensesAverage() {
		const doc = this.doc;
		const date = doc.fixedExpenses.dateRange;
		const head = await dbw.loadTable('transactions');
		const table = getTableName('transactions');
		const amt = 'TRY_CAST("AMOUNT" AS DOUBLE)';
		const result = await head.rawQuery(`
			SELECT SUM(${amt}) as total
			FROM ${table}
			WHERE "ACCTYPE" = 'EP'
				AND TRY_CAST("DOCDATE" AS BIGINT) >= ${date[0]}
				AND TRY_CAST("DOCDATE" AS BIGINT) <= ${date[1]}
		`);
		const sum = (result[0] && Number(result[0].total)) || 0;
		const [d0, d1] = date.map((d) => moment(d));
		const diff = d1.diff(d0, 'month') + 1;
		return sum / diff;
	}
	public async copyExpenses() {
		const doc = this.doc;
		const mmt = moment(doc.fixedExpenses.dateRange[0]);
		const head = await dbw.loadTable('transactions');
		const table = getTableName('transactions');
		const amt = 'TRY_CAST("AMOUNT" AS DOUBLE)';

		// Compute date range covering all 12 months
		const rangeStart = moment(mmt).startOf('month').valueOf();
		const months: Array<{ year: number; month: number }> = [];
		for (let i = 0; i < 12; i++) {
			months.push({ year: mmt.year(), month: mmt.month() + 1 });
			mmt.add(1, 'month');
		}
		const rangeEnd = moment(mmt).subtract(1, 'month').endOf('month').valueOf();

		// Single query with GROUP BY year, month
		const result = await head.rawQuery(`
			SELECT ${sqlExtractYear('"DOCDATE"')},
				${sqlExtractMonth('"DOCDATE"')},
				SUM(${amt}) as total
			FROM ${table}
			WHERE "ACCTYPE" = 'EP'
				AND TRY_CAST("DOCDATE" AS BIGINT) >= ${rangeStart}
				AND TRY_CAST("DOCDATE" AS BIGINT) <= ${rangeEnd}
			GROUP BY year, month
		`);

		const sumByYM: Record<string, number> = {};
		for (const row of result) {
			sumByYM[`${row.year}_${row.month}`] = Number(row.total) || 0;
		}

		const startMmt = moment(doc.fixedExpenses.dateRange[0]);
		const syncResult: number[] = [];
		for (let i = 0; i < 12; i++) {
			const y = startMmt.year();
			const m = startMmt.month() + 1;
			syncResult.push(sumByYM[`${y}_${m}`] || 0);
			startMmt.add(1, 'month');
		}
		return syncResult;
	}
	public get computedFixedExpenses() {
		const doc = this.doc;
		const growth = doc.fixedExpenses.growth;
		const sync = doc.fixedExpenses.syncResult;
		const months = [...sync];
		for (let i = 1; i < 12; i++) {
			months[i] = sync[i] * (1 + growth / 100);
		}
		return months;
	}
	public get limitedComputedExpenses() {
		return this.computedFixedExpenses.slice(0, this.period);
	}
	@Watch('manualFixedExpensesGrowth')
	public onFixedExpensesGrowthChanged(newVal: string) {
		const number = Number(newVal);
		this.doc.fixedExpenses.growth = number;
	}

	public async fromPreviousPage(passData: any) {
		const doc = this.doc;
		if (passData && passData.resync) {
			this.showLoading = true;
			if (doc.fixedExpenses.type === 'average') {
				doc.fixedExpenses.syncResult = await new Array(12).fill(
					this.loadExpensesAverage(),
				);
			} else {
				doc.fixedExpenses.syncResult = await this.copyExpenses();
			}
			doc.fixedExpenses.syncAt = Date.now();
			this.showLoading = false;
		}
	}

	public mounted() {
		const doc = this.doc;

		const fe = doc.fixedExpenses;
		const result = fe.growth;
		this.manualFixedExpensesGrowth = result === result ? result.toString() : '0';
	}
	public onNext() {
		const doc = this.doc;
		const fe = doc.fixedExpenses;
		fe.growth = Number(this.manualFixedExpensesGrowth);
		fe.result = this.computedFixedExpenses;
		fe.resultSet = true;
		this.submit(doc);
	}
	public get nextPage() {
		if (this.editMode === 'fixedExpenses') {
			return '';
		}
		return 'ForecastModalVariableExpenses';
	}
	public get title() {
		return 'Expenses';
	}
	public get okTitle() {
		if (this.nextPage === '') {
			return 'Done';
		}
		return 'Next';
	}
	public get showSkip() {
		if (this.doc.isNew) {
			return false;
		}
		return this.doc.fixedExpenses.resultSet && this.nextPage !== '';
	}
	public get okDisabled() {
		return this.showLoading;
	}
}
